<template>
  <b-badge
    :variant="`light-${meta.variant}`"
    class="job-status"
    :class="[`job-status--${size}`, { 'job-status--pulsing': pulsing }]"
  >
    <span class="job-status__dot" />
    <span class="job-status__label">{{ label }}</span>
  </b-badge>
</template>

<script>
import { jobStatusMeta } from '../job-status'

export default {
  name: 'JobStatusBadge',
  props: {
    status: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'md',
      validator: value => ['sm', 'md'].includes(value),
    },
    // Pass job.isCancelable. A job that can still be cancelled is still in flight,
    // which is how an in-progress status is detected without matching any string.
    // Leave it unset for vocabularies we have not confirmed (output statuses,
    // timing-log statuses) and the badge stays neutral.
    inFlight: {
      type: Boolean,
      default: null,
    },
    // A running job gets a pulsing dot so an in-progress list is readable at a glance.
    animated: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    meta() {
      return jobStatusMeta(this.status, this.inFlight)
    },
    label() {
      // Rendered verbatim, the same as the desktop table's status column.
      return this.status || '-'
    },
    pulsing() {
      return this.animated && this.meta.state === 'running'
    },
  },
}
</script>

<style lang="scss" scoped>
.job-status {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  padding: 5px 10px;
  font-weight: 600;
  line-height: 1;

  &--sm {
    padding: 3px 8px;
    .job-status__label {
      font-size: 11px;
    }
  }

  &--md .job-status__label {
    font-size: 12px;
  }

  &__dot {
    flex: 0 0 auto;
    width: 6px;
    height: 6px;
    margin-right: 6px;
    border-radius: 50%;
    background-color: currentColor;
  }

  &__label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &--pulsing .job-status__dot {
    animation: job-status-pulse 1.4s ease-in-out infinite;
  }
}

@keyframes job-status-pulse {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.35;
    transform: scale(1.35);
  }
}

@media (prefers-reduced-motion: reduce) {
  .job-status--pulsing .job-status__dot {
    animation: none;
  }
}
</style>
